import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App';
import { customMaterialTheme } from './customMaterialTheme';
import { Store } from './Store';

import 'react-toastify/dist/ReactToastify.min.css';
import './Global.less';

// index.html always has an element with ID #root, so it's okay to assume that this will not return null
const root = createRoot(document.getElementById('root')!);

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false
        }
    }
});

root.render(
    <Provider store={Store}>
        <ThemeProvider theme={customMaterialTheme}>
            <BrowserRouter>
                <QueryClientProvider client={queryClient}>
                    <App />
                </QueryClientProvider>
            </BrowserRouter>
        </ThemeProvider>
    </Provider>
);
